import styled from "styled-components";

export const StyledPageHeader = styled.div`
  height: 72px;
  width: 100%;
  max-width: 500px;
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  align-items: center;
  padding: 0 14px;
  margin: 0;
  background: var(--rms-v2-surface);
  border-bottom: 1px solid var(--rms-v2-border-soft);
  box-shadow: none;
  position: sticky;
  top: 0;
  z-index: 1000;
  box-sizing: border-box;

  &.orders-header-stuck {
    border-bottom-color: transparent !important;
  }

  .page-header-action {
    width: 36px;
    height: 36px;
    border: 0;
    background: transparent;
    color: ${(props) => props.primaryColor};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
  }

  .page-header-logo-wrap {
    min-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .page-header-logo {
    display: block;
    height: 32px;
    max-width: 120px;
    object-fit: contain;
  }
`;
